import React from 'react';
import { Dropdown, Icon } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import urls, { codeUrl, relativeUrl } from '@/constants/urls';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import CohortMenuItems from '../containers/CohortMenuItems';

const CohortLauncherDropdownMenu = ({ allowCreate, allowRead, code }) => (
  <Dropdown
    className="aridhia-cohort-launcher-menu"
    icon={null}
    trigger={(<RibbonMenu name="cohorts" message="fair.launcher.cohort" icon="filter" />)}
  >
    <Dropdown.Menu>
      {allowCreate && (
      <Dropdown.Item
        as="a"
        href={codeUrl(urls.COHORT, code, '#')}
        selected={false}
      >
        <Icon name="plus" className="primary" />
        <FormattedMessage id="cohort.header.menu.new" />
      </Dropdown.Item>
      )}
      {allowRead && (
      <>
        <Dropdown.Divider />
        <Dropdown.Item
          as="a"
          href={`#${relativeUrl(urls.COHORTS)}`}
          selected={false}
        >
          <Icon name="list alternate" className="primary" />
          <FormattedMessage id="cohort.header.menu.saved" />
        </Dropdown.Item>
        <CohortMenuItems category="ribbon" />
      </>
      )}
    </Dropdown.Menu>
  </Dropdown>
);

export default CohortLauncherDropdownMenu;
